import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const userService = {
  loginUser: payload => axios.post(Pathes.Auth.login, payload),
  registerUser: payload => axios.post(Pathes.User.registration, payload),
  forgotPassword: payload => axios.post(Pathes.Auth.forgotPassword, payload),
  resetPassword: payload => axios.post(Pathes.Auth.resetPassword, payload),
  changePassword: payload => axios.post(Pathes.Auth.changePassword, payload),
  verifyRecoveryToken: payload => axios.post(Pathes.Auth.verifyToken, payload),
  contactInfo: payload => axios.post(Pathes.User.contactInfoStepTwo, payload),
  phoneVerifyStatus: () => axios.get(Pathes.User.sentCodes),
  sendPhoneCode: payload => axios.post(Pathes.User.sentCodes, payload),
  profile: () => axios.get(Pathes.User.profile),
  userLocation: () => axios.get(Pathes.User.myLocation),
  updateProfilePhoto: payload => axios.post(Pathes.User.updateProfilePhoto, payload),
  updateProfileAbout: payload => axios.post(Pathes.User.updateProfileAbout, payload),
  updateProfileContact: payload => axios.post(Pathes.User.updateProfileContact, payload),
  updateCompany: payload => axios.put(Pathes.User.updateCompany, payload),
  updateCompanyPromo: payload => axios.put(Pathes.User.updatePromo, payload),
  validatePhoneNumber: payload => axios.post(Pathes.User.validatePhoneNumber, payload),
  updateEducation: (id, payload) => axios.put(Pathes.User.education(id), payload),
  createEducation: payload => axios.post(Pathes.User.educationCreate, payload),
  deleteEducation: payload => axios.delete(Pathes.User.educationDelete, payload),
  updateCareer: (id, payload) => axios.put(Pathes.User.career(id), payload),
  createCareer: payload => axios.post(Pathes.User.careerCreate, payload),
  deleteCareer: payload => axios.delete(Pathes.User.careerDelete, payload),
};
